import { apiClient } from "./client";

// ---- Organisation side ----

export async function requestCandidateProfile(dto) {
  const res = await apiClient.post("/organisation/candidate-requests", dto);
  return res.data;
}

export async function listCandidateRequests() {
  const res = await apiClient.get("/organisation/candidate-requests");
  return res.data;
}

/** Withdraws a request the candidate has not answered yet. */
export async function cancelCandidateRequest(requestId) {
  const res = await apiClient.post(
    `/organisation/candidate-requests/${encodeURIComponent(requestId)}/cancel`,
    {},
  );
  return res.data;
}

/** The verified profile of a candidate who accepted this request. */
export async function fetchAcceptedProfile(requestId) {
  const res = await apiClient.get(
    `/organisation/candidate-requests/${encodeURIComponent(requestId)}/profile`,
  );
  return res.data;
}

// ---- Professional side ----

export async function listProfileRequests() {
  const res = await apiClient.get("/professional/profile-requests");
  return res.data;
}

export async function acceptProfileRequest(id) {
  const res = await apiClient.post(
    `/professional/profile-requests/${id}/accept`,
    {},
  );
  return res.data;
}

export async function declineProfileRequest(id) {
  const res = await apiClient.post(
    `/professional/profile-requests/${id}/decline`,
    {},
  );
  return res.data;
}
